import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { fetchTempsProjet } from '../../api/tempsProjetApi';

const SuiviTemps = ({ projetId }) => {
  const [temps, setTemps] = useState([]);

  useEffect(() => {
    console.log("ID du projet reçu :", projetId); // <-- Ajoute cette ligne
    if (!projetId) {
      console.error("projetId est undefined ou null !");
      return;
    }
    const loadTemps = async () => {
      try {
        const data = await fetchTempsProjet(projetId);
        setTemps(data);
      } catch (error) {
        console.error("Erreur lors du chargement des temps :", error);
      }
    };
    loadTemps();
  }, [projetId]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'employe', headerName: 'Employé', width: 200 },
    { field: 'heures', headerName: 'Heures', width: 100 },
    { field: 'date', headerName: 'Date', width: 150 },
  ];

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={temps}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
    </div>
  );
};

export default SuiviTemps;
